import { ITableCol } from "@data/interfaces/itable.interface";
import { ACTIVE_STATUS_OPTIONS } from "@modules/private/active/data/constants/active.constants";
import { ACTIVE_STATUS_COLOR_ENUM, ACTIVE_STATUS_ENUM } from "@modules/private/active/data/enum/active.enum";
import { PROVIDER_STATUS_COLOR_ENUM, PROVIDER_STATUS_ENUM } from "@modules/private/provider/data/enum/provider.enum";

export const PROVIDER_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Activo' },
  { value: 'LOCKED', label: 'Bloqueado' },
  { value: 'DELETED', label: 'Eliminado' }
]

export const PROVIDER_COLUMNS: ITableCol[] = [
  { type: 'text', field: '_id', header: 'id del Proveedor', showFilter: false, dataType: 'link', linkField: '_id', rootLink: 'provider' },
  { type: 'text', field: 'fullName', header: 'Nombre completo', showFilter: true },
  { type: 'text', field: 'rfc', header: 'RFC', showFilter: true },
  { type: 'text', field: 'sector', header: 'Sector', showFilter: true },
  { type: 'text', field: 'subSector', header: 'SubSector', showFilter: true },
  { type: 'date', field: 'createdAt', header: 'Fecha de creación', showFilter: true, dataType: 'date' },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: PROVIDER_STATUS_ENUM, enumColor: PROVIDER_STATUS_COLOR_ENUM, options: PROVIDER_STATUS_OPTIONS },
]

export const ACTIONS = [
  { icon: 'fa-regular fa-pen-to-square', action: 'EDIT', title: 'Editar', color: 'primary', permission: ['providers', 'update'] as [string, string] },
]

export const ASSETS_COLUMNS: ITableCol[] = [
  { type: 'text', field: '_id', header: 'Id del Activo', showFilter: false, dataType: 'link', linkField: '_id', rootLink: 'active' },
  { type: 'text', field: 'name', header: 'Nombre del Activo', showFilter: true },
  { type: 'text', field: 'category', header: 'Categoria', showFilter: true },
  { type: 'text', field: 'brand', header: 'Marca', showFilter: true },
  { type: 'text', field: 'assetModel', header: 'Modelo', showFilter: true },
  { type: 'text', field: 'serie', header: 'Serie', showFilter: true },
  { type: 'text', field: 'version', header: 'Versión', showFilter: true },
  { type: 'text', field: 'color', header: 'Color', showFilter: true },
  { type: 'text', field: 'engineNumber', header: 'Número de Motor', showFilter: true },
  // { type: 'text', field: 'description', header: 'Descripción', showFilter: true },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: ACTIVE_STATUS_ENUM, enumColor: ACTIVE_STATUS_COLOR_ENUM, options: ACTIVE_STATUS_OPTIONS },
]